<template>
  <div class="relative z-1" style="background-color: #e2e2e2; min-height:4px">
    <client-only>
      <ProgressBar
        :bar-color="barColor"
        bg-color="#e2e2e2"
        :val="progress"
        size="small"
        text=""
      />
    </client-only>
  </div>
</template>

<script>
import ProgressBar from 'vue-simple-progress'
import { mapState } from 'vuex'

export default {
  components: { ProgressBar },

  props: {
    progress: { type: Number, default: 0 },
    color: { type: String, default: null },
  },

  computed: {
    barColor() {
      return this.enterprise.theme.palette.primary
    },

    ...mapState(['enterprise']),
  },
}
</script>
